/* eslint: one-var:0 */
'use strict';
(function($) {
	$(window).on('load', function() {
		// レンガレイアウト
		let $masonry = $('.main').masonry({
			itemSelector: '.article',
			columnWidth : '.article.size-s',
			gutter      : 10
		});
		// フィルター
		let $filterNav = $('.js-nav-filter li');
		let $article = $('.article');
		let $articlesClone = $article.clone(); // フィルタリング用のクローンHTML
		$filterNav.on('click', 'a', function(e) {
			let $this = $(e.currentTarget);
			let target = $this.attr('href').split('#')[1];
			let $appendItems = $articlesClone.clone();
			// ナビゲーション部分の更新
			$filterNav.removeClass('is-active')
				.find(`a[href="#${target}"]`)
				.parent()
				.addClass('is-active');
			// すべて以外の場合は追加要素のフィルタリング
			if(target !== 'all') {
				$appendItems = $appendItems.filter(`[data-cat="${target}"]`);
			}
			// masonryアイテムの更新
			$masonry.masonry('remove', $article)
				.masonry('layout')
				.append($appendItems)
				.masonry('appended', $appendItems);
			// article変数の更新
			$article = $appendItems;
		});
	});
}(jQuery));
